export default __webpack_public_path__ + "static/media/powered-by-sorted-v.b6554354.png";